import axios from "@/plugins/axios";

let url = (data) => "/api/console/programs/${_program}/thumb".interpolate(data);

export default {
    post({ _program }, file) {
        var headers = { "Content-Type": "multipart/form-data" };
        var formData = new FormData();
        if (_program) formData.append("_program", _program);
        formData.append("file", file);
        return axios.post(`${url({ _program })}`, formData, { headers }).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url(data)}/${data._id}`).then((result) => result.data);
    },
};
